<!-- 个人绩效弹窗 -->

<template>
    <div>
        <el-dialog title="绩效详情" :visible.sync="dialogVisible" width="30%" append-to-body>
            <div class="box">
                <div style="font-size: 20px;color: black;">
                    本月绩效：200
                </div>

                <div style="font-size: 20px;color: black;margin-top: 15px;">
                    上月绩效：300
                </div>

                <div style="margin-top: 25px;">
                    最近三个月绩效明细
                </div>

                <div style="margin-top: 10px;">
                    <el-date-picker type="months" v-model="value5" placeholder="选择一个或多个月">
                    </el-date-picker>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关 闭</el-button>
                <el-button type="primary">导 出</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

export default {
    name: "individual",
    data () {
        return {
            dialogVisible: false,
            value5: ''
        }
    },

    methods: {

    },
}
</script>

<style scoped></style>